import React from "react";
import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import ChatAvatar from "./ChatAvatar";
import { presenceLabel } from "./chatFormat";
import { useAuthStore } from "./store/useAuthStore";
import { useChatStore } from "./store/useChatStore";

const ChatHeader = ({ onBack }) => {
  const { selectedUser, setSelectedUser } = useChatStore();
  const { onlineUsers } = useAuthStore();

  const recipient = selectedUser?.recipient;
  const isOnline = onlineUsers.includes(recipient?.id);

  return (
    <Box
      display={"flex"}
      alignItems={"center"}
      gap={1.5}
      px={2}
      py={1.25}
      bgcolor={"#fff"}
      borderBottom={"1px solid #ececec"}
    >
      {onBack && (
        <IconButton
          onClick={onBack}
          aria-label="Back to conversations"
          size="small"
          sx={{ ml: -0.5 }}
        >
          <ArrowBackRoundedIcon />
        </IconButton>
      )}

      <ChatAvatar
        participant={recipient}
        size={40}
        showPresence
        isOnline={isOnline}
      />

      <Box flex={1} minWidth={0}>
        <Typography noWrap fontSize={15} fontWeight={700}>
          {recipient?.name || "Pellifix user"}
        </Typography>
        <Typography
          fontSize={12}
          color={isOnline ? "#2e9e4b" : "text.secondary"}
        >
          {presenceLabel(recipient, isOnline)}
        </Typography>
      </Box>

      <Tooltip title="Close conversation">
        <IconButton
          onClick={() => setSelectedUser(null)}
          aria-label="Close conversation"
          size="small"
        >
          <CloseRoundedIcon />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default ChatHeader;
